import { styled } from '@mui/material'

import { BaseContainer, BaseItem } from '../../../configs/styles/BaseGrid'

export const Container = styled(BaseContainer)``

export const Item = styled(({ order, ...props }) => <BaseItem {...props} />)`
  &.MuiGrid-item {
    display: flex;
    order: ${props => props.order};
  }
`
